<template>
  <div class="top-content top-fixed" :style="{background: background}">
    <div class="box ">
      <!-- 左侧：logo 和菜单栏 -->
      <div class="left-section">
        <!--  logo  -->
        <div class="logo-img">
          <el-image :src="src" style="max-width: 120px; height: 40px;" alt="活动"/>
        </div>

        <!--  快捷菜单 -->
        <div class="menu-container">
          <el-menu :ellipsis="false" class="el-menu-demo" mode="horizontal" :router="true" active-text-color="#409EFF">
            <el-menu-item index="1"
                          class="menu-item"
                          @click="handleGoto('/')">首页
            </el-menu-item>
            <el-menu-item index="2"
                          class="menu-item"
                          @click="handleGoto('/task')">任务大厅
            </el-menu-item>
            <el-menu-item index="3"
                          class="menu-item"
                          @click="handleGoto('/service')">找服务商
            </el-menu-item>
            <el-menu-item index="4"
                          class="menu-item"
                          @click="handleGoto('/cases')">项目案例
            </el-menu-item>
            <!--            <el-menu-item index="5" @click="handleGoto('/media/profile')">媒体发布</el-menu-item>-->
          </el-menu>
        </div>
      </div>

      <!-- 右侧：搜索框 和 登录注册按钮 -->
      <div class="right-section">
        <!--  搜索框  -->
        <div class="top-search">
          <el-input v-model="input" :suffix-icon="SearchIcon" style="width: 240px" size="default"
                    placeholder="搜索您感兴趣的东西"/>
        </div>

        <!--  登录注册按钮  -->
        <div class="login-register-btn">
          <div v-if="!isLogin">
            <el-button type="primary" size="large" @click="handlerOpenLoginModal">登录/注册</el-button>
          </div>
          <div v-else>
            <el-popover placement="bottom" :width="420">
              <template #reference>
                <el-avatar :size="35" :src="userInfo.avatar"/>
              </template>
              <template #default>
                <div>
                  <el-row :gutter="20" align="middle">
                    <el-col :span="10">
                      <div
                          style="min-height: 250px; display: flex; flex-direction: column; justify-content: center;padding: 0 20px;border-right: solid 1px #e7e6e4">
                        <div style="width: 50px; text-align: center; margin: 0 auto">
                          <el-avatar :size="50" :src="userInfo.avatar"/>
                        </div>
                        <div style="margin: 20px 0" class="user-nick">
                          <el-text size="default" type="info"> {{ userInfo.nickName || userInfo.phone }}</el-text>
                        </div>
                        <div style="text-align: center">
                          <el-button :icon="SwitchButton" plain round @click="handlerLogout">退出登录</el-button>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="14">
                      <el-row :gutte="10">
                        <el-col :span="12">
                          <div class="info-menu-item-box" @click="handleGoto('/mine/center')">
                            <el-avatar :size="40" :src="icon.zhsz"/>
                            <div>
                              <el-text size="default" type="info">账户设置</el-text>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="info-menu-item-box" @click="handleGoto('/finance/mine')">
                            <el-avatar :size="40" :src="icon.cwsz"/>
                            <div>
                              <el-text size="default" type="info">财务管理</el-text>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="info-menu-item-box" @click="handleGoto('/taskCenter/mine')">
                            <el-avatar :size="40" :src="icon.fbrw"/>
                            <div>
                              <el-text size="default" type="info">项目中心</el-text>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="info-menu-item-box" @click="handleGoto('/user/index')">

                            <el-avatar :size="40" :src="icon.grzx"/>
                            <div>
                              <el-text size="default" type="info">个人中心</el-text>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="info-menu-item-box" style="text-align: left;padding-top: 0">
                            <el-text size="small" type="info">登录时间：{{ userInfo.lastLoginTime }}</el-text>
                            <br>
                            <el-text size="small" type="info">登录 IP：{{ userInfo.lastLoginIp }}</el-text>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </div>
              </template>
            </el-popover>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/logo.png'
import {Search} from '@element-plus/icons-vue'
import grzx from '@/assets/icon/grzx.png'
import cwsz from '@/assets/icon/cwsz.png'
import fbrw from '@/assets/icon/fbrw.png'
import zhsz from '@/assets/icon/zhsz.png'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Top",

  props: {
    activeIndex: {
      type: String,
      default: '1'
    },
    background: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      icon: {
        grzx: grzx,
        cwsz: cwsz,
        fbrw: fbrw,
        zhsz: zhsz
      },

      src: logo,
      input: '',
      SearchIcon: Search,
      userInfo: null,
      isLogin: false
    }
  },
  mounted() {
    console.log('Top mounted')
    this.$bus.on('top:getUserInfo', this.getUserInfo)
    this.getUserInfo()
  },
  unmounted() {
    console.log('Top unmounted')
    this.$bus.off('top:getUserInfo', this.getUserInfo)
  },
  methods: {
    handleGoto(page) {
      if (page) {
        if (page === '/finance/mine') {
          this.$modal.notice('支付模块正在完善建设中，即将上线中....', 'warning', "系统提示")
        } else if (page === '/user/index') {
          this.$modal.notice('个人评价体系正在完善建设中，即将上线中....', 'warning', "系统提示")
        } else {
          this.$router.push(page)
        }
      } else {
        this.$modal.notice('功能开发中...', 'warning', "系统提示")
      }
    },
    //点击登录弹窗
    handlerOpenLoginModal() {
      this.$bus.emit('loginModal:open')
    },
    // 获取用户信息
    getUserInfo() {
      this.userInfo = this.$store.state.user.userInfo
      this.isLogin = !!this.userInfo;
    },
    handlerCommand(command) {
      if (command === 'logout') {
        this.handlerLogout()
      }
    },


    handlerLogout() {
      this.$store.dispatch('user/logout').then(() => {
        this.getUserInfo()
      })
    }
  }
}
</script>

<style scoped>

.user-nick {
  text-align: center;
  color: #333;
  font: 12px/24px 微软雅黑, MicrosoftYaHei, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Open Sans, Helvetica Neue, Source Sans Pro, Arial, sans-serif, system-ui, Noto Sans;
}

.info-menu-item-box {
  cursor: pointer;
  text-align: center;
  padding: 10px 15px 15px 10px;
  color: #333;
  font: 12px/24px 微软雅黑, MicrosoftYaHei, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Open Sans, Helvetica Neue, Source Sans Pro, Arial, sans-serif, system-ui, Noto Sans;
}

.user-info-box {
  width: 300px;
}

.top-content {

  padding-top: 10px;
  height: 60px;
  //background-color: #FFF;
  //background: linear-gradient(to bottom, #A6D2EF, #B1D8F1);


  .box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #666666;
    margin: 0 auto;
    max-width: 1400px;
    box-sizing: border-box;

    .left-section {
      display: flex;
      align-items: center;

      .logo-img {
        padding-right: 30px;
        //border-right: 1px solid #B8D8E9;
      }

      .menu-container {
        margin-left: 30px;

        .el-menu-demo {
          border-bottom: none;
          background-color: transparent;
        }
      }
    }

    .right-section {
      display: flex;
      align-items: center;

      .top-search {
        margin-right: 15px;
      }
    }
  }
}

.menu-item {
  color: black;
  font-weight: 600;
  line-height: 28px;
  font-size: 18px;
  white-space: normal;
  font-family: "PingFang SC", "Helvetica Neue", "Arial", "Hiragino Sans GB", "Microsoft YaHei UI", "Microsoft YaHei", "SimSun", sans-serif;;
}


/* 将 Top 组件固定在页面顶部 */
.top-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
}

/* 响应式设计 - 小屏幕时调整布局 */
@media (max-width: 768px) {
  .box {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 10px;
  }

  .left-section {
    order: 1;
    width: 70%;
  }

  .right-section {
    order: 2;
    width: 30%;
    justify-content: flex-end;
  }
}
</style>
